import { Toast } from "../../components";
import RegisterContainer from "./RegisterContainer";
import RegisterVerifyContainer from "./RegisterVerifyContainer";
function RegisterVerify() {
    const getError = (data) => {
        if (data) {
            Toast.open(data, "danger")
        }
    }
    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer verify>
                <RegisterVerifyContainer header={'Xác thực tài khoản'} back={'/register'} register getError={getError} />
            </RegisterContainer>
        </>
    )
}

export default RegisterVerify;